'use strict';
/**
 * Verify OOS items if deferred cleanup is required
 * @param {Object} model - Cart model from server response
 * @param {function} callback - Callback function to execute after verification
 */
function verifyOOSIfRequired(model, callback) {
    var basket = model.basket ? model.basket : (model.cart ? model.cart : model); // eslint-disable-line
    if (!basket || !basket.OOSListModificationRequired) {
        callback(model);
        return;
    }

    $.ajax({
        url: $('.cart-verify-oos-url').val(), // Cart-VerifyOOS URL exposed in ISML
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            $.spinner().stop();
            callback(data); // return modified data
        },
        error: function () {
            $.spinner().stop();
            callback(model); // fallback
        }
    });
}
module.exports = {
    verifyOOSIfRequired: verifyOOSIfRequired
};
